import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { CacheService } from '../cache.service';
import { Router } from '@angular/router';
import { NS_Enums } from '../shared/namespaces';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { SentryService } from '../services/sentry/sentry.service';
import { isExplicitLogoutPending } from '../shared/helpers/explicit-logout.helper';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private afAuth: AngularFireAuth, private authService: AuthService, private cacheService: CacheService, private router: Router, private sentryService: SentryService) { }

  ngOnInit(): void {
    // Only a sign-out the user asked for ends the shared Saras session. Other visits here (a
    // different global user, a failed user load) sign back in from `saras_global` via
    // `DIFFERENT_USER`, so they must keep that cookie.
    const explicitLogout = isExplicitLogoutPending();
    if (explicitLogout) {
      this.cacheService.removeSharedCookie();
    } else {
      window[NS_Enums.windowKeysEnum.global_status] = 'DIFFERENT_USER';
    }
    this.afAuth.signOut().then(() => {
      this.sentryService.clearUserInfo();
      if (explicitLogout) {
        this.cacheService.clear();
      }
      this.router.navigate(['/login']);
    });
  }

}
